const OpportunityTabs = ({ activeTab, onTabChange, counts = {} }) => {
  const tabs = [
    { key: "all", label: "All", count: counts.all },
    { key: "internships", label: "Internships", count: counts.internships },
    { key: "hackathons", label: "Hackathons", count: counts.hackathons },
    { key: "placements", label: "Placements", count: counts.placements },
  ];

  return (
    <div className="flex max-w-full items-center gap-1 overflow-x-auto rounded-xl border border-slate-200 bg-white p-1 shadow-sm">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          onClick={() => onTabChange(tab.key)}
          className={`flex shrink-0 items-center gap-2 rounded-lg px-4 py-2.5 text-sm font-semibold transition-all duration-200 ${
            activeTab === tab.key
              ? "bg-indigo-600 text-white shadow-sm"
              : "text-slate-500 hover:bg-slate-50 hover:text-slate-800"
          }`}
        >
          {tab.label}
          {tab.count !== undefined && (
            <span
              className={`text-xs px-1.5 py-0.5 rounded-full ${
                activeTab === tab.key
                  ? "bg-white/20 text-white"
                  : "bg-slate-100 text-slate-500"
              }`}
            >
              {tab.count}
            </span>
          )}
        </button>
      ))}
    </div>
  );
};

export default OpportunityTabs;
